/* SearchLoading.tsx generated by @compiled/babel-plugin v0.26.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _20 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _19 = "._1e0c1ule{display:block}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _18 = "._18u0idpf{margin-left:0}";
const _17 = "._otyridpf{margin-bottom:0}";
const _16 = "._2hwxidpf{margin-right:0}";
const _15 = "._19pkidpf{margin-top:0}";
const _14 = "._vwz4f6fq{line-height:18px}";
const _13 = "._k48p1nn1{font-weight:400}";
const _12 = "._ect48q0o{font-family:Charlie Text}";
const _11 = "._1wyboqnp{font-size:.75rem}";
const _10 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _9 = "._1yt4qgg4{padding:var(--_x3fubp)}";
const _8 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _7 = "._1e0cglyw{display:none}";
const _6 = "._18m915vq{overflow-y:hidden}";
const _5 = "._1reo15vq{overflow-x:hidden}";
const _4 = "._o5721q9c{white-space:nowrap}";
const _3 = "._1bto1l2s{text-overflow:ellipsis}";
import { SkeletonItem } from '@atlaskit/menu';
import { BodySmall } from '@atlassian/mpac-primitives';
import { ellipsisCompiled } from '@atlassian/mpac-ui/theme';
import React from 'react';
import { desktopOnly, mobileOnly } from '../../SearchUtils/ResponsiveUtils';
const _2 = "._n3td1eps{padding-bottom:var(--ds-space-100)}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_n3td1eps", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const baseLabel = {
  padding: "var(--ds-space-250)".concat(" ", "var(--ds-space-250)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"),
  color: "var(--ds-text-subtle)",
  fontSize: '0.75rem',
  fontFamily: 'Charlie Text',
  fontWeight: 400,
  lineHeight: '18px',
  margin: 0
};
const LargeLabel = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_x3fubp": ix("var(--ds-space-250)".concat(" ", "var(--ds-space-250)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"))
    }),
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0cglyw _dm251ule _1yt4qgg4 _syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LargeLabel.displayName = 'LargeLabel';
}
const SmallLabel = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _19, _20, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_x3fubp": ix("var(--ds-space-250)".concat(" ", "var(--ds-space-250)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"))
    }),
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1ule _dm25glyw _1yt4qgg4 _syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SmallLabel.displayName = 'SmallLabel';
}
export const SearchLoading = _ref4 => {
  let {
    count,
    query
  } = _ref4;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "skeleton-items"
  }, /*#__PURE__*/React.createElement(LargeLabel, null, "Suggestions for \u2018", query, "\u2019"), /*#__PURE__*/React.createElement(SmallLabel, null, "Suggestions"), Array.from({
    length: count
  }).map((_, index) => /*#__PURE__*/React.createElement(SkeletonItem, {
    hasIcon: true,
    isShimmering: true,
    key: index,
    testId: "skeleton-item-".concat(index)
    // cssFn is Deprecated and a better way will be introduced soon --> https://atlassian.slack.com/archives/CFJ9DU39U/p1699329222735429?thread_ts=1699264489.543679&cid=CFJ9DU39U
    ,
    cssFn: () => {
      return {
        height: '2.5rem'
      };
    }
  })));
};